import React, { useContext, useState } from 'react';

import { media } from 'context';
import { BOTTOM_NAVIGATION_HEIGHT, Img, Layout, Link, NavItem, Text } from 'ds';

import { NAV_ICON_CONFIG } from './constants';

export interface Props extends Omit<NavItem, 'key' | 'iconName'> {
  theme: 'light' | 'dark' | 'white' | 'dark_blue';
  isActive: boolean;
  displayDot?: boolean;
  isExpanded?: boolean;
  index?: number;
  imageKey: string;
}

const NavImage: React.FC<Props> = ({
  isActive,
  href,
  theme,
  label,
  onClick,
  displayDot,
  isExpanded,
  index,
  imageKey
}) => {
  const { hoverColor, activeColor, activeHoverColor, mouseDownColor } = NAV_ICON_CONFIG[theme];
  const { isMobile } = useContext(media);
  const [mouseDown, setMouseDown] = useState<boolean>(false);

  return (
    <Link href={href} name={JSON.stringify(label)} opacity={false} display="block" onClick={onClick}>
      {isMobile ? (
        <Layout inline justify="center" align="center" direction="column" height={BOTTOM_NAVIGATION_HEIGHT}>
          <Layout position="relative" justify="center" align="center">
            <Layout width={48} height={48}>
              <Img srcKey={imageKey} alt={label} width={360} height={360} folder="ux" />
            </Layout>
            {!!displayDot && (
              <Layout
                position="absolute"
                top={0}
                right={-4}
                width={8}
                height={8}
                borderRadius="circular"
                color="blue-500"
              />
            )}
          </Layout>
        </Layout>
      ) : (
        <Layout
          {...(isMobile ? {} : isExpanded ? { padding: 8 } : { padding: 8 })}
          color={isActive ? activeColor : mouseDown ? mouseDownColor : undefined}
          align="center"
          borderRadius={8}
          justify="flex-start"
          hoverColor={isMobile || mouseDown ? undefined : isActive ? activeHoverColor : hoverColor}
          onMouseDown={() => setMouseDown(true)}
          onMouseUp={() => setMouseDown(false)}
          onMouseLeave={() => setMouseDown(false)}
          inline
        >
          <Layout position="relative" justify="center" align="center">
            <Layout width={20} height={20}>
              <Img srcKey={imageKey} alt={label} width={360} height={360} folder="ux" />
            </Layout>
            {!!displayDot && !isExpanded && (
              <Layout
                position="absolute"
                top={-4}
                right={-4}
                width={12}
                height={12}
                borderRadius="circular"
                borderWidth={2}
                borderColor={isActive ? activeColor : 'blue-25'}
                color="blue-500"
              />
            )}
          </Layout>
          {isExpanded && (
            <Layout
              marginLeft={12}
              __className="NavIcon-label"
              __style={index ? { animationDuration: '120ms' } : {}}
              align="center"
            >
              <Text size="body3" color={isActive ? 'blue-500' : 'gray-500'} ellipsis>
                {label}
              </Text>
              {!!displayDot && !!isExpanded && (
                <Layout marginLeft={6} width={8} height={8} borderRadius="circular" color="blue-500" />
              )}
            </Layout>
          )}
        </Layout>
      )}
    </Link>
  );
};

export default NavImage;
